import { render, staticRenderFns } from "./N3OsDados.vue?vue&type=template&id=4de8d23c&scoped=true"
import script from "./N3OsDados.vue?vue&type=script&lang=js"
export * from "./N3OsDados.vue?vue&type=script&lang=js"
import style1 from "./N3OsDados.vue?vue&type=style&index=1&id=4de8d23c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de8d23c",
  null
  
)

export default component.exports